import React from 'react'

export interface PatternProps extends React.ComponentPropsWithoutRef<'svg'> {
  variant?: 'style1' | 'style2' | 'style3'
}

export const Pattern = ({ variant = 'style1', ...restProps }: PatternProps) => {
  return (
    <svg
      width="260"
      height="250"
      viewBox="0 0 260 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      {variant === 'style1' && <Pattern1 />}
      {variant === 'style2' && <Pattern2 />}
      {variant === 'style3' && <Pattern3 />}

      <Mask />
      <Defs />
    </svg>
  )
}

const Pattern1 = () => {
  return (
    <g mask="url(#shade_mask)">
      <rect x="6.5" y="1.5" width="41" height="41" stroke="currentColor" />
      <rect x="6.5" y="42.5" width="41" height="41" stroke="currentColor" />
      <rect x="6.5" y="83.5" width="41" height="41" stroke="currentColor" />
      <rect x="6.5" y="124.5" width="41" height="41" stroke="currentColor" />
      <rect x="6.5" y="165.5" width="41" height="41" stroke="currentColor" />
      <rect x="6.5" y="206.5" width="41" height="41" stroke="currentColor" />
      <rect x="47.5" y="1.5" width="41" height="41" stroke="currentColor" />
      <rect x="47.5" y="42.5" width="41" height="41" stroke="currentColor" />
      <rect x="47.5" y="83.5" width="41" height="41" stroke="currentColor" />
      <rect x="47.5" y="124.5" width="41" height="41" stroke="currentColor" />
      <rect x="47.5" y="165.5" width="41" height="41" stroke="currentColor" />
      <rect x="47.5" y="206.5" width="41" height="41" stroke="currentColor" />
      <rect x="88.5" y="1.5" width="41" height="41" stroke="currentColor" />
      <rect x="88.5" y="42.5" width="41" height="41" stroke="currentColor" />
      <rect x="88.5" y="83.5" width="41" height="41" stroke="currentColor" />
      <rect x="88.5" y="124.5" width="41" height="41" stroke="currentColor" />
      <rect x="88.5" y="165.5" width="41" height="41" stroke="currentColor" />
      <rect x="88.5" y="206.5" width="41" height="41" stroke="currentColor" />
      <rect x="129.5" y="1.5" width="41" height="41" stroke="currentColor" />
      <rect x="129.5" y="42.5" width="41" height="41" stroke="currentColor" />
      <rect x="129.5" y="83.5" width="41" height="41" stroke="currentColor" />
      <rect x="129.5" y="124.5" width="41" height="41" stroke="currentColor" />
      <rect x="129.5" y="165.5" width="41" height="41" stroke="currentColor" />
      <rect x="129.5" y="206.5" width="41" height="41" stroke="currentColor" />
      <rect x="170.5" y="1.5" width="41" height="41" stroke="currentColor" />
      <rect x="170.5" y="42.5" width="41" height="41" stroke="currentColor" />
      <rect x="170.5" y="83.5" width="41" height="41" stroke="currentColor" />
      <rect x="170.5" y="124.5" width="41" height="41" stroke="currentColor" />
      <rect x="170.5" y="165.5" width="41" height="41" stroke="currentColor" />
      <rect x="170.5" y="206.5" width="41" height="41" stroke="currentColor" />
      <rect x="211.5" y="1.5" width="41" height="41" stroke="currentColor" />
      <rect x="211.5" y="42.5" width="41" height="41" stroke="currentColor" />
      <rect x="211.5" y="83.5" width="41" height="41" stroke="currentColor" />
      <rect x="211.5" y="124.5" width="41" height="41" stroke="currentColor" />
      <rect x="211.5" y="165.5" width="41" height="41" stroke="currentColor" />
      <rect x="211.5" y="206.5" width="41" height="41" stroke="currentColor" />
    </g>
  )
}

const Pattern2 = () => {
  return (
    <g mask="url(#shade_mask)">
      <rect
        x="6.5"
        y="1.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="6.5"
        y="42.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="6.5"
        y="83.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="6.5"
        y="124.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="6.5"
        y="165.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="6.5"
        y="206.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="47.5"
        y="1.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="47.5"
        y="42.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="47.5"
        y="83.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="47.5"
        y="124.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="47.5"
        y="165.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="47.5"
        y="206.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="88.5"
        y="1.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="88.5"
        y="42.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="88.5"
        y="83.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="88.5"
        y="124.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="88.5"
        y="165.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="88.5"
        y="206.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="129.5"
        y="1.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="129.5"
        y="42.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="129.5"
        y="83.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="129.5"
        y="124.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="129.5"
        y="165.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="129.5"
        y="206.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="170.5"
        y="1.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="170.5"
        y="42.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="170.5"
        y="83.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="170.5"
        y="124.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="170.5"
        y="165.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="170.5"
        y="206.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="211.5"
        y="1.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="211.5"
        y="42.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="211.5"
        y="83.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="211.5"
        y="124.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="211.5"
        y="165.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
      <rect
        x="211.5"
        y="206.5"
        width="41"
        height="41"
        rx="20.5"
        stroke="currentColor"
      />
    </g>
  )
}

const Pattern3 = () => {
  return (
    <g mask="url(#shade_mask)">
      <path
        d="M3.84937 12.7887L25 0.57735L46.1506 12.7887V37.2113L25 49.4226L3.84937 37.2113V12.7887Z"
        stroke="currentColor"
      />
      <path
        d="M45.8494 12.7887L67 0.57735L88.1506 12.7887V37.2113L67 49.4226L45.8494 37.2113V12.7887Z"
        stroke="currentColor"
      />
      <path
        d="M87.8494 12.7887L109 0.57735L130.151 12.7887V37.2113L109 49.4226L87.8494 37.2113V12.7887Z"
        stroke="currentColor"
      />
      <path
        d="M129.849 12.7887L151 0.57735L172.151 12.7887V37.2113L151 49.4226L129.849 37.2113V12.7887Z"
        stroke="currentColor"
      />
      <path
        d="M171.849 12.7887L193 0.57735L214.151 12.7887V37.2113L193 49.4226L171.849 37.2113V12.7887Z"
        stroke="currentColor"
      />
      <path
        d="M213.849 12.7887L235 0.57735L256.151 12.7887V37.2113L235 49.4226L213.849 37.2113V12.7887Z"
        stroke="currentColor"
      />
      <path
        d="M3.84937 62.7887L25 50.5774L46.1506 62.7887V87.2113L25 99.4226L3.84937 87.2113V62.7887Z"
        stroke="currentColor"
      />
      <path
        d="M45.8494 62.7887L67 50.5774L88.1506 62.7887V87.2113L67 99.4226L45.8494 87.2113V62.7887Z"
        stroke="currentColor"
      />
      <path
        d="M87.8494 62.7887L109 50.5774L130.151 62.7887V87.2113L109 99.4226L87.8494 87.2113V62.7887Z"
        stroke="currentColor"
      />
      <path
        d="M129.849 62.7887L151 50.5774L172.151 62.7887V87.2113L151 99.4226L129.849 87.2113V62.7887Z"
        stroke="currentColor"
      />
      <path
        d="M171.849 62.7887L193 50.5774L214.151 62.7887V87.2113L193 99.4226L171.849 87.2113V62.7887Z"
        stroke="currentColor"
      />
      <path
        d="M213.849 62.7887L235 50.5774L256.151 62.7887V87.2113L235 99.4226L213.849 87.2113V62.7887Z"
        stroke="currentColor"
      />
      <path
        d="M3.84937 112.789L25 100.577L46.1506 112.789V137.211L25 149.423L3.84937 137.211V112.789Z"
        stroke="currentColor"
      />
      <path
        d="M45.8494 112.789L67 100.577L88.1506 112.789V137.211L67 149.423L45.8494 137.211V112.789Z"
        stroke="currentColor"
      />
      <path
        d="M87.8494 112.789L109 100.577L130.151 112.789V137.211L109 149.423L87.8494 137.211V112.789Z"
        stroke="currentColor"
      />
      <path
        d="M129.849 112.789L151 100.577L172.151 112.789V137.211L151 149.423L129.849 137.211V112.789Z"
        stroke="currentColor"
      />
      <path
        d="M171.849 112.789L193 100.577L214.151 112.789V137.211L193 149.423L171.849 137.211V112.789Z"
        stroke="currentColor"
      />
      <path
        d="M213.849 112.789L235 100.577L256.151 112.789V137.211L235 149.423L213.849 137.211V112.789Z"
        stroke="currentColor"
      />
      <path
        d="M3.84937 162.789L25 150.577L46.1506 162.789V187.211L25 199.423L3.84937 187.211V162.789Z"
        stroke="currentColor"
      />
      <path
        d="M45.8494 162.789L67 150.577L88.1506 162.789V187.211L67 199.423L45.8494 187.211V162.789Z"
        stroke="currentColor"
      />
      <path
        d="M87.8494 162.789L109 150.577L130.151 162.789V187.211L109 199.423L87.8494 187.211V162.789Z"
        stroke="currentColor"
      />
      <path
        d="M129.849 162.789L151 150.577L172.151 162.789V187.211L151 199.423L129.849 187.211V162.789Z"
        stroke="currentColor"
      />
      <path
        d="M171.849 162.789L193 150.577L214.151 162.789V187.211L193 199.423L171.849 187.211V162.789Z"
        stroke="currentColor"
      />
      <path
        d="M213.849 162.789L235 150.577L256.151 162.789V187.211L235 199.423L213.849 187.211V162.789Z"
        stroke="currentColor"
      />
      <path
        d="M3.84937 212.789L25 200.577L46.1506 212.789V237.211L25 249.423L3.84937 237.211V212.789Z"
        stroke="currentColor"
      />
      <path
        d="M45.8494 212.789L67 200.577L88.1506 212.789V237.211L67 249.423L45.8494 237.211V212.789Z"
        stroke="currentColor"
      />
      <path
        d="M87.8494 212.789L109 200.577L130.151 212.789V237.211L109 249.423L87.8494 237.211V212.789Z"
        stroke="currentColor"
      />
      <path
        d="M129.849 212.789L151 200.577L172.151 212.789V237.211L151 249.423L129.849 237.211V212.789Z"
        stroke="currentColor"
      />
      <path
        d="M171.849 212.789L193 200.577L214.151 212.789V237.211L193 249.423L171.849 237.211V212.789Z"
        stroke="currentColor"
      />
      <path
        d="M213.849 212.789L235 200.577L256.151 212.789V237.211L235 249.423L213.849 237.211V212.789Z"
        stroke="currentColor"
      />
    </g>
  )
}

const Defs = () => (
  <defs>
    <radialGradient
      id="radial-mask"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(129.5 124.5) rotate(90) scale(123.5)"
    >
      <stop stopColor="#D9D9D9" />
      <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
    </radialGradient>
  </defs>
)

const Mask = () => (
  <mask
    id="shade_mask"
    style={{ maskType: 'alpha' }}
    maskUnits="userSpaceOnUse"
    x="6"
    y="1"
    width="247"
    height="247"
  >
    <rect x="6" y="1" width="247" height="247" fill="url(#radial-mask)" />
  </mask>
)
